import React from 'react';
import { useState, useEffect } from 'react';
import Div from '../Div';

export default function VideoModal({ videoSrc, bgUrl, variant, isOpen, onClose }) {
  const [iframeSrc, setIframeSrc] = useState('about:blank');
  const [toggle, setToggle] = useState(isOpen || false);
  
  useEffect(() => {
    if (isOpen) {
      handleVideoSrcUpdate(videoSrc);
      setToggle(true);
    }
  }, [isOpen, videoSrc]);

  const handleVideoSrcUpdate = (src) => {
    let videoId;
    if (src.includes('?v=')) {
      videoId = src.split('?v=')[1].trim();
    } else if (src.includes('youtu.be/')) {
      videoId = src.split('youtu.be/')[1].trim();
    } else {
      videoId = src;
    }
    
    // Remove any additional parameters
    if (videoId.includes('&')) {
      videoId = videoId.split('&')[0];
    }
    
    setIframeSrc(`https://www.youtube.com/embed/${videoId}`);
  };
  
  const handelClick = () => {
    if (!isOpen) { // Only handle click if not controlled externally
      handleVideoSrcUpdate(videoSrc);
      setToggle(!toggle);
    }
  };
  
  const handelClose = () => {
    setIframeSrc('about:blank');
    setToggle(false);
    if (onClose) {
      onClose();
    }
  };
  
  return (
    <>
      {bgUrl && (
        <Div
          className={`cs-video_block ${
            variant ? variant : 'cs-style1'
          } cs-video_open cs-bg`}
          style={{ backgroundImage: `url(${bgUrl})` }}
          onClick={handelClick}
        >
          <span className="cs-player_btn cs-accent_color">
            <span />
          </span>
        </Div>
      )}
      <Div className={toggle ? 'cs-video_popup active' : 'cs-video_popup'}>
        <Div className="cs-video_popup_overlay" />
        <Div className="cs-video_popup_content">
          <Div className="cs-video_popup_layer" />
          <Div className="cs-video_popup_container">
            <Div className="cs-video_popup_align">
              <Div className="embed-responsive embed-responsive-16by9">
                <iframe
                  className="embed-responsive-item"
                  src={iframeSrc}
                  title="video modal"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </Div>
            </Div>
            <Div className="cs-video_popup_close" onClick={handelClose} />
          </Div>
        </Div>
      </Div>
    </>
  );
}
